export default __webpack_public_path__ + "static/media/parking.6106bd97.svg";